import { GET_OTHER_SERVICES } from './../constants';
import { handleActions } from "redux-actions"

export const otherServices  = handleActions(
    {
        [ GET_OTHER_SERVICES ]: (state, action) => {
            //console.log(action.payload)
            if(action.payload.data.length > 0){
                return action.payload.data
            }else{
                return []
            }
        }
    }, []
)